import RequiredValidator from "@/validators/RequiredValidator";
import {NumberValidator} from "@/validators/NumberValidator";

export default class OrderRules {

	public static readonly companyIdRules = [
		(new RequiredValidator('company.singular')).validationRule(),
	];

	public static readonly nameRules = [
		(new RequiredValidator('order.name')).validationRule(),
	];

	public static readonly dateFromRules = [];

	public static readonly dateToRules = [];

	public static readonly hourlyRateRules = [
		(new NumberValidator('order.hourlyRate')).validationRule(),
	];

	public static readonly dailyLumpSumRules = [
		(new NumberValidator('order.dailyLumpSum')).validationRule(),
	];

}
